import { connect } from 'react-redux'
import Document from './DocumentView'
import { getFromSettings } from 'src/utils/helpers'

import { resetApp } from 'src/modules/App/actions'
import { resetUser } from 'src/modules/Users/actions'
import { setAddedToWallet } from 'src/modules/Documents/actions'
import { addedToWallet, hasSlipConsent } from '../reselect'

const mapDispatchToProps = {
  resetUser,
  resetApp,
  setAddedToWallet,
}

const mapStateToProps = state => {
  return {
    document: state.documents.document,
    isChatEmpty: state.chat.isChatEmpty,
    isWidgetState: state.appReducer.isWidget,
    labels: getFromSettings(state, 'labels', {}),
    addedToWallet: addedToWallet(state),
    countryIsoCode: getFromSettings(state, 'countryIsoCode'),
    hasSlipConsent: hasSlipConsent(state),
    features: state.appReducer.features,
    subdomain: state.appReducer.settings.subdomain,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Document)
